export const InvalidIcon = () => (
  <svg width="7" height="7" viewBox="0 0 7 7" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.64642 1.03033L6.11609 0.5L0.742016 5.87407L1.27235 6.4044L6.64642 1.03033Z" fill="currentColor" />
    <path d="M1.21783 0.53217L0.6875 1.0625L6.06157 6.43657L6.5919 5.90624L1.21783 0.53217Z" fill="currentColor" />
  </svg>
);
